import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { 
  Home, ArrowUpCircle, ArrowDownCircle, Send, History, User, Settings, 
  Shield, LogOut, Bell, CheckCircle, Star, Filter, Download, Search, Calendar
} from "lucide-react";

// Browser Frame Component with theme support
const BrowserFrame = ({ theme = 'light' }) => {
  const isLight = theme === 'light';
  const bgColor = isLight ? '#dee1e6' : '#202124';
  const tabBgInactive = isLight ? '#f1f3f4' : '#35363a';
  const tabBgActive = isLight ? '#fff' : '#292a2d';
  const textColor = isLight ? '#5f6368' : '#9aa0a6';
  const textColorActive = isLight ? '#202124' : '#e8eaed';
  const addressBarBg = isLight ? '#f1f3f4' : '#35363a';
  
  return (
    <div className="flex-shrink-0" style={{ backgroundColor: bgColor }}>
      <div className="flex items-center h-[38px]" style={{ backgroundColor: bgColor }}>
        <div className="flex items-end flex-1 pl-2">
          <div className="flex items-center h-[34px] px-3 rounded-t-lg min-w-[140px] max-w-[200px] mr-[1px] cursor-pointer" style={{ backgroundColor: tabBgInactive }}>
            <img src="/ozon-favicon.ico" alt="" className="w-4 h-4 mr-2 flex-shrink-0" />
            <span className="text-[13px] truncate flex-1" style={{ color: textColor }}>Ozon Карта</span>
          </div>
          <div className="flex items-center h-[34px] px-3 rounded-t-lg min-w-[140px] max-w-[200px] mr-[1px] cursor-pointer" style={{ backgroundColor: tabBgActive }}>
            <img src="/onesix-favicon.ico" alt="" className="w-4 h-4 mr-2 flex-shrink-0" />
            <span className="text-[13px] truncate flex-1" style={{ color: textColorActive }}>ONESIX History</span>
          </div>
          <button className="w-7 h-7 flex items-center justify-center rounded-full ml-1 mb-1" style={{ color: textColor }}>
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
          </button>
        </div>
        <div className="flex items-center h-full">
          <button className="w-[46px] h-full flex items-center justify-center hover:bg-[#c8cace]" style={{ color: textColor }}><svg className="w-[10px] h-[1px]" viewBox="0 0 10 1"><rect fill="currentColor" width="10" height="1"/></svg></button>
          <button className="w-[46px] h-full flex items-center justify-center hover:bg-[#c8cace]" style={{ color: textColor }}><svg className="w-[10px] h-[10px]" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1"><rect x="0.5" y="0.5" width="9" height="9"/></svg></button>
          <button className="w-[46px] h-full flex items-center justify-center hover:bg-[#e81123] hover:text-white" style={{ color: textColor }}><svg className="w-[10px] h-[10px]" viewBox="0 0 10 10" stroke="currentColor" strokeWidth="1.2"><line x1="0" y1="0" x2="10" y2="10"/><line x1="10" y1="0" x2="0" y2="10"/></svg></button>
        </div>
      </div>
      <div className="flex items-center h-[40px] px-2" style={{ backgroundColor: tabBgActive }}>
        <div className="flex items-center gap-1 mr-2">
          <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: textColor }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg></button>
          <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: isLight ? '#dadce0' : '#5f6368' }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg></button>
          <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: textColor }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg></button>
        </div>
        <div className="flex-1 flex items-center h-[32px] px-4 rounded-full" style={{ backgroundColor: addressBarBg }}>
          <svg className="w-4 h-4 mr-3 flex-shrink-0" style={{ color: textColor }} viewBox="0 0 24 24" fill="currentColor"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg>
          <span className="text-[14px]" style={{ color: textColorActive }}>onesix.io/history</span>
        </div>
        <div className="flex items-center gap-1 ml-3">
          <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: textColor }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg></button>
          <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: textColor }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="2"/><circle cx="12" cy="5" r="2"/><circle cx="12" cy="19" r="2"/></svg></button>
        </div>
      </div>
    </div>
  );
};

// Crypto icons
const CryptoIcon = ({ symbol, size = 'md' }) => {
  const icons = {
    USDT: { bg: 'linear-gradient(135deg, #26A17B, #1a7d5f)', text: '₮' },
    BTC: { bg: 'linear-gradient(135deg, #F7931A, #c77615)', text: '₿' },
    ETH: { bg: 'linear-gradient(135deg, #627EEA, #4a62b8)', text: 'Ξ' },
    USDC: { bg: 'linear-gradient(135deg, #2775CA, #1d5a9e)', text: '$' },
    RUB: { bg: 'linear-gradient(135deg, #8B5CF6, #6D28D9)', text: '₽' },
  };
  const icon = icons[symbol] || { bg: 'linear-gradient(135deg, #8B5CF6, #6D28D9)', text: '₽' };
  const sizeClass = size === 'sm' ? 'w-8 h-8 text-sm' : 'w-10 h-10 text-lg';
  return (
    <div 
      className={`${sizeClass} rounded-xl flex items-center justify-center text-white font-bold shadow-lg`}
      style={{ background: icon.bg }}
    >
      {icon.text}
    </div>
  );
};

export default function NovapayPayments() {
  const [searchParams] = useSearchParams();
  const [data, setData] = useState(null);
  const [activeFilter, setActiveFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [showBrowser, setShowBrowser] = useState(true);
  const [browserTheme, setBrowserTheme] = useState('light');
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);

  useEffect(() => {
    const dataParam = searchParams.get('data');
    const browserParam = searchParams.get('showBrowser');
    const themeParam = searchParams.get('theme');
    
    if (browserParam !== null) {
      setShowBrowser(browserParam !== 'false');
    }
    if (themeParam) {
      setBrowserTheme(themeParam);
    }
    const filterParam = searchParams.get('filter');
    if (filterParam && ['all', 'deposit', 'withdrawal'].includes(filterParam)) {
      setActiveFilter(filterParam);
    }
    
    if (dataParam) {
      try {
        const parsed = JSON.parse(decodeURIComponent(dataParam));
        setData(parsed);
        if (parsed.showBrowser !== undefined) {
          setShowBrowser(parsed.showBrowser);
        }
        if (parsed.browserTheme) {
          setBrowserTheme(parsed.browserTheme);
        }
        
        // Calculate date range from transactions
        if (parsed.transactions && parsed.transactions.length > 0) {
          const dates = parsed.transactions
            .map(tx => {
              if (!tx.date) return null;
              const parts = tx.date.split('.');
              if (parts.length !== 3) return null;
              const [day, month, year] = parts;
              return { 
                original: tx.date, 
                sortValue: parseInt(year) * 10000 + parseInt(month) * 100 + parseInt(day) 
              };
            })
            .filter(d => d !== null);
          
          if (dates.length > 0) {
            dates.sort((a, b) => a.sortValue - b.sortValue);
            setDateFrom(dates[0].original);
            setDateTo(dates[dates.length - 1].original);
          }
        }
        
        // Use dateFrom/dateTo from data if provided
        if (parsed.dateFrom) setDateFrom(parsed.dateFrom);
        if (parsed.dateTo) setDateTo(parsed.dateTo);
        // Read default filter
        if (parsed.defaultFilter && ['all', 'deposit', 'withdrawal'].includes(parsed.defaultFilter)) {
          setActiveFilter(parsed.defaultFilter);
        }
      } catch (e) {
        console.error("Error parsing data:", e);
      }
    }
  }, [searchParams]);

  if (!data) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-violet-600 via-blue-600 to-indigo-700 flex items-center justify-center">
        <div className="text-white text-lg">Загрузка...</div>
      </div>
    );
  }

  const accountName = `${data.firstName || ''} ${data.lastName || ''}`.trim() || 'Пользователь';
  const userId = data.novapayId || Math.floor(100000 + Math.random() * 900000);

  const menuItems = [
    { icon: Home, label: 'Главная', id: 'main' },
    { icon: ArrowUpCircle, label: 'Пополнить', id: 'deposit' },
    { icon: ArrowDownCircle, label: 'Вывести', id: 'withdraw' },
    { icon: Send, label: 'Перевод', id: 'transfer' },
    { icon: History, label: 'История', id: 'history', active: true },
    { icon: User, label: 'Профиль', id: 'profile' },
    { icon: Shield, label: 'Безопасность', id: 'security' },
    { icon: Settings, label: 'Настройки', id: 'settings' },
  ];

  // Map transactions from OZON profile - swap deposit/withdrawal
  const transactions = (data.transactions || []).map((tx, index) => ({
    id: index + 1,
    type: tx.type === 'deposit' ? 'withdrawal' : 'deposit',
    amount: tx.amount || 0,
    crypto: ['USDT', 'BTC', 'ETH', 'USDC'][index % 4],
    date: tx.date || new Date().toLocaleDateString('ru-RU'),
    time: tx.time || new Date().toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }),
    status: 'completed',
    description: tx.description || (tx.type === 'deposit' ? 'Вывод средств' : 'Пополнение баланса')
  })).sort((a, b) => {
    const pa = a.date.split('.');
    const pb = b.date.split('.');
    const va = parseInt(pa[2]) * 10000 + parseInt(pa[1]) * 100 + parseInt(pa[0]);
    const vb = parseInt(pb[2]) * 10000 + parseInt(pb[1]) * 100 + parseInt(pb[0]);
    if (vb !== va) return vb - va;
    return (b.time || '').localeCompare(a.time || '');
  });

  // Helper: parse DD.MM.YYYY to sortable number, returns null if invalid
  const parseDateValue = (dateStr) => {
    if (!dateStr) return null;
    const m = dateStr.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    if (!m) return null;
    return parseInt(m[3]) * 10000 + parseInt(m[2]) * 100 + parseInt(m[1]);
  };

  // Filter by date range (only when valid dates are entered)
  const dateFilteredTransactions = transactions.filter(tx => {
    const txVal = parseDateValue(tx.date);
    if (txVal === null) return true;

    const fromVal = parseDateValue(dateFrom);
    if (fromVal !== null && txVal < fromVal) return false;

    const toVal = parseDateValue(dateTo);
    if (toVal !== null && txVal > toVal) return false;

    return true;
  });

  const filteredTransactions = dateFilteredTransactions.filter(tx => {
    if (activeFilter === 'deposit') return tx.type === 'deposit';
    if (activeFilter === 'withdrawal') return tx.type === 'withdrawal';
    return true;
  }).filter(tx => {
    if (!searchQuery) return true;
    return tx.description.toLowerCase().includes(searchQuery.toLowerCase());
  });

  const totalDeposits = transactions.filter(t => t.type === 'deposit').reduce((sum, t) => sum + Math.abs(t.amount), 0);
  const totalWithdrawals = transactions.filter(t => t.type === 'withdrawal').reduce((sum, t) => sum + Math.abs(t.amount), 0);

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#f8fafc', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      {showBrowser && <BrowserFrame theme={browserTheme} />}
      <div className="flex-1 flex bg-slate-50">
      {/* Sidebar */}
      <aside className="w-64 bg-gradient-to-b from-violet-600 via-blue-600 to-indigo-700 flex flex-col shadow-2xl">
        {/* Logo */}
        <div className="p-5 border-b border-white/10">
          <div className="flex items-center justify-center">
            <img src="/onesix-logo-white.svg" alt="ONESIX Crypto Wallet" className="h-10 object-contain" />
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 py-4 overflow-y-auto">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.id}
                className={`w-full flex items-center gap-3 px-5 py-3 text-sm transition-all ${
                  item.active 
                    ? 'bg-white/20 text-white border-r-4 border-white' 
                    : 'text-blue-100 hover:bg-white/10 hover:text-white'
                }`}
              >
                <Icon className="w-5 h-5" />
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>

        {/* Logout */}
        <div className="p-4 border-t border-white/10">
          <button className="w-full flex items-center gap-3 px-4 py-2.5 text-blue-200 hover:text-white hover:bg-white/10 rounded-lg transition-colors">
            <LogOut className="w-5 h-5" />
            <span>Выйти</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Header */}
        <header className="bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between shadow-sm">
          <div>
            <h2 className="text-xl font-bold text-slate-800">История платежей</h2>
            <p className="text-slate-500 text-sm">Все операции по вашему кошельку</p>
          </div>
          
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 px-3 py-1.5 bg-green-50 border border-green-200 rounded-full">
              <CheckCircle className="w-4 h-4 text-green-600" />
              <span className="text-green-700 text-sm font-medium">Верифицирован</span>
            </div>
            
            <button className="p-2 text-slate-500 hover:text-slate-700 relative">
              <Bell className="w-5 h-5" />
              <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
            </button>
            
            <div className="flex items-center gap-3 pl-4 border-l border-slate-200">
              <div className="w-9 h-9 bg-gradient-to-br from-violet-500 to-blue-600 rounded-full flex items-center justify-center shadow-lg">
                <span className="text-white text-sm font-bold">
                  {accountName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)}
                </span>
              </div>
              <div>
                <p className="text-sm font-medium text-slate-800">{accountName}</p>
                <p className="text-xs text-slate-500">ID: {userId}</p>
              </div>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 p-6 overflow-auto bg-slate-50">
          {/* Stats Cards */}
          <div className="grid grid-cols-3 gap-4 mb-6">
            <div className="bg-white rounded-xl p-5 shadow-sm border border-slate-100">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
                  <ArrowUpCircle className="w-6 h-6 text-green-600" />
                </div>
                <div>
                  <p className="text-slate-500 text-sm">Всего пополнений</p>
                  <p className="text-2xl font-bold text-slate-800">{totalDeposits.toLocaleString()} ₽</p>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-xl p-5 shadow-sm border border-slate-100">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center">
                  <ArrowDownCircle className="w-6 h-6 text-red-600" />
                </div>
                <div>
                  <p className="text-slate-500 text-sm">Всего выводов</p>
                  <p className="text-2xl font-bold text-slate-800">{totalWithdrawals.toLocaleString()} ₽</p>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-xl p-5 shadow-sm border border-slate-100">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-violet-100 rounded-xl flex items-center justify-center">
                  <History className="w-6 h-6 text-violet-600" />
                </div>
                <div>
                  <p className="text-slate-500 text-sm">Всего операций</p>
                  <p className="text-2xl font-bold text-slate-800">{transactions.length}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Transactions Table */}
          <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
            {/* Filters */}
            <div className="p-4 border-b border-slate-100 flex items-center justify-between flex-wrap gap-3">
              <div className="flex items-center gap-4 flex-wrap">
                <div className="flex items-center gap-2">
                  <Filter className="w-4 h-4 text-slate-400" />
                  <div className="flex gap-1 bg-slate-100 p-1 rounded-lg">
                    {[
                      { id: 'all', label: 'Все' },
                      { id: 'deposit', label: 'Ввод' },
                      { id: 'withdrawal', label: 'Вывод' },
                    ].map(filter => (
                      <button
                        key={filter.id}
                        onClick={() => setActiveFilter(filter.id)}
                        className={`px-4 py-1.5 rounded-md text-sm font-medium transition-colors ${
                          activeFilter === filter.id 
                            ? 'bg-white text-slate-800 shadow-sm' 
                            : 'text-slate-500 hover:text-slate-700'
                        }`}
                      >
                        {filter.label}
                      </button>
                    ))}
                  </div>
                </div>
                
                {/* Date Range Filter */}
                <div className="flex items-center gap-2 px-3 py-1.5 bg-violet-50 border border-violet-200 rounded-lg">
                  <Calendar className="w-4 h-4 text-violet-600" />
                  <input
                    type="text"
                    placeholder="ДД.ММ.ГГГГ"
                    value={dateFrom || ''}
                    onChange={(e) => setDateFrom(e.target.value || null)}
                    className="w-[100px] text-sm text-violet-700 font-medium bg-transparent border-none outline-none placeholder-violet-400"
                  />
                  <span className="text-sm text-violet-500">—</span>
                  <input
                    type="text"
                    placeholder="ДД.ММ.ГГГГ"
                    value={dateTo || ''}
                    onChange={(e) => setDateTo(e.target.value || null)}
                    className="w-[100px] text-sm text-violet-700 font-medium bg-transparent border-none outline-none placeholder-violet-400"
                  />
                  {(dateFrom || dateTo) && (
                    <button
                      onClick={() => { setDateFrom(null); setDateTo(null); }}
                      className="ml-1 text-violet-400 hover:text-violet-600 text-xs"
                    >
                      ✕
                    </button>
                  )}
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <div className="relative">
                  <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
                  <input
                    type="text"
                    placeholder="Поиск..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="pl-9 pr-4 py-2 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent"
                  />
                </div>
                <button className="flex items-center gap-2 px-4 py-2 text-slate-600 hover:text-slate-800 border border-slate-200 rounded-lg text-sm">
                  <Download className="w-4 h-4" />
                  Экспорт
                </button>
              </div>
            </div>

            {/* Table */}
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-slate-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Тип</th>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Описание</th>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Сумма</th>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Дата</th>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Статус</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {filteredTransactions.length === 0 ? (
                    <tr>
                      <td colSpan={5} className="px-6 py-12 text-center text-slate-400">
                        Операции не найдены
                      </td>
                    </tr>
                  ) : (
                    filteredTransactions.map((tx) => (
                      <tr key={tx.id} className="hover:bg-slate-50 transition-colors">
                        <td className="px-6 py-4">
                          <div className="flex items-center gap-3">
                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                              tx.type === 'deposit' ? 'bg-green-100' : 'bg-red-100'
                            }`}>
                              {tx.type === 'deposit' ? (
                                <ArrowUpCircle className="w-4 h-4 text-green-600" />
                              ) : (
                                <ArrowDownCircle className="w-4 h-4 text-red-600" />
                              )}
                            </div>
                            <span className={`text-sm font-medium ${
                              tx.type === 'deposit' ? 'text-green-600' : 'text-red-600'
                            }`}>
                              {tx.type === 'deposit' ? 'Ввод' : 'Вывод'}
                            </span>
                          </div>
                        </td>
                        <td className="px-6 py-4">
                          <p className="text-sm text-slate-800">{tx.description}</p>
                          <p className="text-xs text-slate-400">{tx.crypto}</p>
                        </td>
                        <td className="px-6 py-4">
                          <span className={`text-sm font-semibold ${
                            tx.type === 'deposit' ? 'text-green-600' : 'text-red-600'
                          }`}>
                            {tx.type === 'deposit' ? '+' : '-'}{Math.abs(tx.amount).toLocaleString()} ₽
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <p className="text-sm text-slate-800">{tx.date}</p>
                          <p className="text-xs text-slate-400">{tx.time}</p>
                        </td>
                        <td className="px-6 py-4">
                          <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-green-100 text-green-700 text-xs font-medium rounded-full">
                            <CheckCircle className="w-3 h-3" />
                            Выполнено
                          </span>
                        </td>
                        {/* TX Hash removed */}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            
            {/* Pagination - hidden when all data fits on one page */}
          </div>
        </main>
      </div>
      </div>
    </div>
  );
}
